import { Link } from "react-router-dom";
import React from "react";
import { MdOutlineLaptopChromebook } from "react-icons/md";
import { FaDatabase, FaAward, FaHandHoldingDollar } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import { LuRefreshCw, LuScanFace } from "react-icons/lu";
import { LuUserRoundCheck } from "react-icons/lu";
import { BiTask } from "react-icons/bi";
import { TbUserPin } from "react-icons/tb";
import { MdMobileScreenShare } from "react-icons/md";
import {
  MdCircleNotifications,
  MdOutlineReceiptLong,
  MdOutlineAccessTime,
} from "react-icons/md";
import { SiGoogleforms } from "react-icons/si";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { MdCampaign } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { GiTakeMyMoney } from "react-icons/gi";

import "swiper/css";
import "swiper/css/navigation";

const features = [
  {
    title: "Payroll Management",
    desc: "Process salaries, generate payslips, manage deductions, and automate monthly payroll operations with full statutory compliance",
    icon: <FaDatabase size={28} color="#10324F" aria-hidden="true" />,
    link: "/payroll-management",
  },
  {
    title: "Attendance Management",
    desc: "Track employee attendance, working hours, late marks, and daily attendance records accurately across all teams",
    icon: <SlCalender size={28} color="#10324F" aria-hidden="true" />,
    link: "/attendance-management",
  },
  {
    title: "Shift Management",
    desc: "Create shifts, assign schedules, and manage workforce availability with better visibility and shift-based attendance rules",
    icon: <LuRefreshCw size={28} color="#10324F" aria-hidden="true" />,
    link: "/shift-management",
  },
  {
    title: "Leave Management",
    desc: "Handle leave requests, approvals, balances, and employee leave records from one centralised HR dashboard",
    icon: <LuUserRoundCheck size={28} color="#10324F" aria-hidden="true" />,
    link: "/leave-management",
  },
  {
    title: "Task Management",
    desc: "Assign tasks, track deadlines, monitor completion progress, and improve individual and team accountability",
    icon: <BiTask size={30} color="#10324F" aria-hidden="true" />,
    link: "/task-management",
  },
  {
    title: "Geo-Location Attendance",
    desc: "Enable location-based attendance tracking for field staff, remote employees, and multi-site workforce operations",
    icon: <TbUserPin size={28} color="#10324F" aria-hidden="true" />,
    link: "/geo-location-attendance",
  },
  {
    title: "Selfie-Based Attendance",
    desc: "Verify employee attendance with selfie check-ins eliminating proxy attendance and improving HR record accuracy",
    icon: <MdMobileScreenShare size={28} color="#10324F" aria-hidden="true" />,
    link: "/selfie-based-attendance",
  },
  {
    title: "Reminder Management",
    desc: "Manage employee reminders, follow-ups, approvals, and recurring business activities efficiently from one place",
    icon: (
      <MdCircleNotifications size={28} color="#10324F" aria-hidden="true" />
    ),
    link: "/reminder-management",
  },
  {
    title: "Tax & Forms Management",
    desc: "Organise payroll compliance, statutory records, employee forms, and all tax-related documentation in one place",
    icon: <SiGoogleforms size={28} color="#10324F" aria-hidden="true" />,
    link: "/tax-form-management",
  },
  {
    title: "Face Recognition Attendance",
    desc: "Mark employee attendance with AI-powered face recognition, selfie verification and GPS verification",
    icon: <LuScanFace size={28} color="#10324F" aria-hidden="true" />,
    link: "/face-recognition-attendance",
    isNew: true,
  },
  {
    title: "Company Announcements",
    desc: "Publish, manage, and share important company updates and notices with all employees from one centralised HR dashboard",
    icon: <MdCampaign size={28} color="#10324F" aria-hidden="true" />,
    link: "/company-announcements",
  },
  {
    title: "Profile Settings",
    desc: "Update employee profiles, manage personal details, configure access permissions, and keep workforce records accurate and current",
    icon: <IoSettingsOutline size={28} color="#10324F" aria-hidden="true" />,
    link: "/profile-settings",
  },
  {
    title: "Employee Bonus Management",
    desc: "Define bonus structures, set eligibility criteria, calculate payouts, and disburse employee bonuses with complete transparency and control",
    icon: <FaAward size={28} color="#10324F" aria-hidden="true" />,
    link: "/employee-bonus",
    isNew: true,
  },
  {
    title: "Expense Management",
    desc: "Submit,review and approve employee expense claims with policy-based controls,real-time tracking and seamless reimbursement workflows",
    icon: <MdOutlineReceiptLong size={28} color="#10324F" aria-hidden="true" />,
    link: "/expense-management",
    isNew: true,
  },
  {
    title: "Incentive Management",
    desc: "Design incentive programs, track performance-linked rewards, and manage payouts to motivate teams and drive measurable business outcomes",
    icon: <GiTakeMyMoney size={28} color="#10324F" aria-hidden="true" />,
    link: "/incentive-management",
    isNew: true,
  },
  {
    title: "Overtime Management",
    desc: "Track employee overtime hours, apply configured pay rules, and process overtime compensation accurately within your payroll cycle",
    icon: <MdOutlineAccessTime size={28} color="#10324F" aria-hidden="true" />,
    link: "/overtime-management",
    isNew: true,
  },
  {
    title: "Loan & Advance Salary",
    desc: "Manage employee loan requests, advance salary approvals, repayment schedules, and deductions directly from a centralised HR system",
    icon: <FaHandHoldingDollar size={28} color="#10324F" aria-hidden="true" />,
    link: "/loan-advance-management",
    isNew: true,
  },
];

export default function OurFeature() {
  return (
    <section
      id="OurFeature"
      className="relative overflow-hidden py-10 px-6 bg-[#F6F9FB]"
    >
      {/* Blur dots */}

      <div className="max-w-6xl mx-auto mb-8">
        {/* Section header */}
        <div className="text-center mb-14">
          <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold leading-snug uppercase mb-4">
            Smarter Tools for Payroll,
            <br /> Attendance & Workforce Management
          </h2>

          <p className="section-desc">
            Everything from attendance tracking and payroll processing to
            compliance management organized in one powerful HRMS solution
          </p>
        </div>

        {/* Cards */}
        <div>
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            navigation
            autoplay={{ delay: 3000 }}
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 3 },
            }}
          >
            {features.map((item, index) => (
              <SwiperSlide
                key={index}
                className="flex justify-center h-full pb-6 pt-6"
              >
                <div
                  className="relative bg-white rounded-[14px] p-8 w-full
    shadow-[0_10px_10px_rgba(13,59,93,0.12)]
    transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_16px_40px_rgba(13,59,93,0.18)]"
                >
                  <div className="flex flex-col items-center h-full">
                    {/* {item.isNew && (
                      <div className="absolute top-0 left-0 overflow-hidden w-24 h-24 z-20 pointer-events-none">
                        <div className="absolute top-4 -left-8 w-28 -rotate-45 bg-[#FF0000] text-white text-[10px] font-bold tracking-wider text-center py-1 shadow-lg uppercase">
                          NEW
                        </div>
                      </div>
                    )} */}
                    {item.isNew && (
                      <div className="absolute top-0 right-0 overflow-hidden w-24 h-24 pointer-events-none z-10">
                        <div className="absolute top-4 -right-8 w-32 rotate-45 bg-[#FF0000] text-white text-sm font-bold text-center py-1 shadow-lg uppercase">
                          NEW
                        </div>
                      </div>
                    )}
                    {/* Icon */}
                    <div className="flex justify-center mb-5">
                      <div
                        className="
                      relative
                      w-16.25 h-16.5
                      mx-auto mb-6
                      rounded-xl
                      bg-white
                      flex items-center justify-center
                      shadow-[0_6px_20px_rgba(13,59,93,0.15)]
                      p-3.25        
                    "
                      >
                        <div className="flex items-center justify-center">
                          {item.icon}
                        </div>
                      </div>
                    </div>
                    {/* Content */}
                    <h2 className="text-[#10324F] font-roboto font-semibold text-[18px] text-center mb-3">
                      {item.title}
                    </h2>
                    <p className="text-[#10324F] font-roboto font-light text-[14px] leading-[180%] text-center mb-6 grow">
                      {item.desc}
                    </p>
                    {/* Button */}
                    <Link
                      to={item.link}
                      className="font-roboto font-medium text-[15px] text-[#10324F]
    bg-[linear-gradient(180deg,rgba(209,223,234,0.052)_50.18%,rgba(209,223,234,0.2)_100%)]
    backdrop-blur-[6px]
    border border-[#D1DFEA]
    px-14 py-3
    rounded-md
    shadow-[0_6px_18px_rgba(0,0,0,0.12)]
    transition-all duration-200
    hover:-translate-y-0.5
    hover:shadow-[0_10px_24px_rgba(0,0,0,0.16)]
    active:translate-y-0

  "
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
